export default "__VITE_ASSET__CXsDru_e__"